import {
  USER_FIND_OR_CREATE_REQUESTED,
  USER_FIND_OR_CREATE_SUCCESS,
  USER_FIND_OR_CREATE_FAILURE,
  STORE_FIND_OR_CREATE_REQUESTED,
  STORE_FIND_OR_CREATE_SUCCESS,
  STORE_FIND_OR_CREATE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  user: null,
  isFetching: false,
  status: 'waiting',
  errors: null
};

const users = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case USER_FIND_OR_CREATE_REQUESTED:
    case STORE_FIND_OR_CREATE_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting'
      });

    case USER_FIND_OR_CREATE_SUCCESS:
    case STORE_FIND_OR_CREATE_SUCCESS:
      return Object.assign({}, state, {
        user: action.payload.user,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case USER_FIND_OR_CREATE_FAILURE:
    case STORE_FIND_OR_CREATE_FAILURE:
      return Object.assign({}, null, {
        isFetching: false,
        status: 'waiting',
        errors: 'error here'
      })

    default:
      return state;
  }
}

export default users;
